
























import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

declare let Stripe: any

// Set your publishable key: remember to change this to your live publishable key in production
// See your keys here: https://dashboard.stripe.com/account/apikeys
const stripe = Stripe(process.env.VUE_APP_STRIPE_API_KEY_PUBLIC);
const elements = stripe.elements();

@Component
export default class PaymentCardComponent extends Vue {
    @Prop()
    performActionText: string|undefined // 'Pay' if undefined
    @Prop()
    onPerformActionRequested: ((paymentMethodId: string, zipCode: string|undefined) => void)|undefined
    @Prop()
    isPerformingAction: boolean|undefined
    @Prop({ type: Boolean, default: true })
    isActionEnabled: boolean|undefined
    cardElement: stripe.elements.Element|undefined
    formErrorMessage: string|null = null
    isCreatingToken: boolean = false

    // noinspection JSUnusedGlobalSymbols
    mounted() {
        // Set up Stripe.js and Elements to use in checkout form
        const style = {
            base: {
                color: "#32325d",
                fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                fontSmoothing: "antialiased",
                fontSize: "16px",
                "::placeholder": {
                    color: "#aab7c4"
                }
            },
            invalid: {
                color: "#fa755a",
                iconColor: "#fa755a"
            }
        };

        this.cardElement = elements.create("card", { style: style });
        if (this.cardElement) {
            this.cardElement.mount("#card-element");
            this.cardElement.on('change', (event: any) => {
                this.formErrorMessage = event.error?.message || null
            });
        }
    }

    // noinspection JSUnusedGlobalSymbols
    beforeDestroy() {
        if (this.cardElement) {
            this.cardElement.unmount()
            this.cardElement.destroy()
        }
    }

    getPerformActionText(): string {
        return this.performActionText || 'Pay'
    }

    get isBusy(): boolean {
        return this.isCreatingToken || !!this.isPerformingAction
    }

    async onPayClicked() {
        this.isCreatingToken = true
        try {
            const result: stripe.PaymentMethodResponse = await stripe.createPaymentMethod({
                type: 'card',
                card: this.cardElement
            })
            if (result.error)
                this.formErrorMessage = result.error.message || 'Error processing card'
            else if (this.onPerformActionRequested && result.paymentMethod?.id)
                this.onPerformActionRequested(result.paymentMethod.id, result.paymentMethod?.billing_details?.address?.postal_code)
        } catch (error) {
            console.log(error)
        }
        this.isCreatingToken = false
    }
}
